/* import __COLOCATED_TEMPLATE__ from './standard-modal-header-with-links.hbs.js'; */
/**
## StandardHeaderWithLinks

Displays a modal header with links in the top-right corner.

### Parameters
@param {String} title - The title for the modal
@param {Array<Object>} linkConfigs - Array of `link` Hash objects describing the text, action, and disabled status of the link:
@param {String} linkConfigs[].label - Display text of the link.
@param {Action} linkConfigs[].action - Closure action to execute when the link is clicked.
@param {Boolean} linkConfigs[].isDisabled - Whether or not the link should be disabled.

Sass dependencies at: `components/modals/_standard-header-with-link.sass`
*/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'header',
  classNames: ['modal-layout__header', 'modals__standard-header-with-links']
});